module.exports = __webpack_public_path__ + "static/warehouse-exp-img-3-element-b6f1f92f1d76ec7021d1c06b67897d3b.png";